import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Check from "@mui/icons-material/Check";
import Close from "@mui/icons-material/Close";
import ContentCopy from "@mui/icons-material/ContentCopy";
import { useTranslation } from "../../../hooks/useTranslation";

const SHOWN_MS = 1500;

type Props = { value: string; label?: string };

// A small copy button for the developer tools; for a moment it turns into a
// check once copied, or a red cross when the browser refused.
export const CopyIconButton = ({ value, label }: Props) => {
  const { translate } = useTranslation("pages.admin.header.copy");
  const [outcome, setOutcome] = useState<"copied" | "failed" | null>(null);

  const show = (next: "copied" | "failed") => {
    setOutcome(next);
    window.setTimeout(() => setOutcome(null), SHOWN_MS);
  };

  return (
    <Tooltip
      title={outcome ? translate(outcome) : (label ?? translate("copy"))}
    >
      <IconButton
        size="small"
        aria-label={label ?? translate("copy")}
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(value);
            show("copied");
          } catch {
            show("failed");
          }
        }}
        sx={{
          p: 0.5,
          color:
            outcome === "copied"
              ? "success.main"
              : outcome === "failed"
                ? "error.main"
                : "text.secondary",
        }}
      >
        {outcome === "copied" && <Check sx={{ fontSize: 16 }} />}
        {outcome === "failed" && <Close sx={{ fontSize: 16 }} />}
        {outcome === null && <ContentCopy sx={{ fontSize: 16 }} />}
      </IconButton>
    </Tooltip>
  );
};
